import { render } from "./EditInquiry.vue?vue&type=template&id=abdb0430&scoped=true"
import script from "./EditInquiry.vue?vue&type=script&lang=js"
export * from "./EditInquiry.vue?vue&type=script&lang=js"

import "./EditInquiry.vue?vue&type=style&index=0&id=abdb0430&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdb0430"]])

export default __exports__